import { render } from "./NftStorage.vue?vue&type=template&id=51bc77c0&scoped=true"
import script from "./NftStorage.vue?vue&type=script&lang=js"
export * from "./NftStorage.vue?vue&type=script&lang=js"

import "./NftStorage.vue?vue&type=style&index=0&id=51bc77c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51bc77c0"]])

export default __exports__